













import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import AsiContentContainer from "../common/AsiContentContainer.vue";
import UserCardBasicData from "./UserCardBasicData.vue";
import UserCardContactAddress from "./UserCardContactAddress.vue";
import UserCardPendingReports from "./UserCardPendingReports.vue";
import UserCardAdditionalInfos from "./UserCardAdditionalInfos.vue";
import UserCardSettings from "./UserCardSettings.vue";
import User from "@/models/user/User";
import CardBlamable from "@/components/CardBlamable.vue";
import {Permissions} from "@/helpers/constants";

@Component({
	components: {
		CardBlamable,
		UserCardSettings,
		UserCardAdditionalInfos,
		UserCardPendingReports, UserCardContactAddress, UserCardBasicData, AsiContentContainer
	}
})
export default class UserTabDetails extends Vue {

	@Prop({type: Object, required: true})
	public user!: User;

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	@Emit('userChanged')
	public userChanged(event: Event): Event {
		return event;
	}

}
